import script from "./CatalogPublicationFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogPublicationFilters.vue?vue&type=script&setup=true&lang=js"

import "./CatalogPublicationFilters.vue?vue&type=style&index=0&id=3bf3132c&lang=scss"
import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__